module.exports = __webpack_public_path__ + "img/V77.1e330560.jpg";